/**
 * Dernier filet : ce qui s’affiche quand un écran lève une erreur non
 * rattrapée. On montre le message réel — un back-office est utilisé par des
 * gens qui appellent le support, et « une erreur est survenue » ne les aide pas.
 */

import { isRouteErrorResponse, useRouteError } from 'react-router'

import { messageErreur } from '../lib/api'
import { Button } from '../ui/Button'
import { BandeauErreur } from '../ui/EmptyState'

export function ErreurRoute() {
  const erreur = useRouteError()

  const message = isRouteErrorResponse(erreur)
    ? `${String(erreur.status)} — ${erreur.statusText}`
    : messageErreur(erreur, 'Erreur inattendue.')

  return (
    <main className="mx-auto flex max-w-2xl flex-col gap-4 p-8">
      <h1 className="text-xl font-semibold text-slate-900">L’écran n’a pas pu s’afficher</h1>
      <BandeauErreur message={message} />
      <div className="flex gap-2">
        <Button
          onClick={() => {
            window.location.reload()
          }}
        >
          Recharger la page
        </Button>
        <Button
          variante="secondaire"
          onClick={() => {
            window.history.back()
          }}
        >
          Revenir en arrière
        </Button>
      </div>
    </main>
  )
}
